import IconCard from 'organisms/Cards/IconCard';

const NoResults = () => (
  <div className="flex flex-col items-center gap-4">
    <h2 className="font-spaceGrotesk text-display-sm font-semibold text-gray-900">
      We don&apos;t have that connector yet.
    </h2>
    <p className="text-lg text-gray-700">
      However, our connector library is easily extensible. Check out these options below.
    </p>
    <div className="dark mt-4 grid grid-cols-1 gap-8 lg:grid-cols-3">
      <IconCard
        iconId="dataflow-03"
        title="Custom Connector"
        description="Use Prismatic’s custom connector SDK to build a robust connector to any app your customers use."
        button={{
          label: 'Learn More',
          href: '/docs/custom-connectors/',
          className:
            '!text-buttonText-linkColor dark:text-primary-50 hover:text-buttonText-linkColorHover dark:hover:text-primary-100 disabled:text-buttonText-linkColorDisabled dark:disabled:text-primary-700',
        }}
        darkCard={false}
      />
      <IconCard
        iconId="code-browser"
        title="HTTP"
        description="The HTTP connector provides universal connectivity to any app with an HTTP based API (most apps.)"
        button={{
          label: 'Learn More',
          href: '/docs/components/http',
          className:
            '!text-buttonText-linkColor dark:text-primary-50 hover:text-buttonText-linkColorHover dark:hover:text-primary-100 disabled:text-buttonText-linkColorDisabled dark:disabled:text-primary-700',
        }}
        darkCard={false}
      />
      <IconCard
        iconId="message-text-square-02"
        title="Request Connector"
        description="Contact us to request the connector you’re looking for. "
        button={{
          label: 'Learn More',
          href: '/request-a-connector',
          className:
            '!text-buttonText-linkColor dark:text-primary-50 hover:text-buttonText-linkColorHover dark:hover:text-primary-100 disabled:text-buttonText-linkColorDisabled dark:disabled:text-primary-700',
        }}
        darkCard={false}
      />
    </div>
  </div>
);

export default NoResults;
